import Cookies from 'js-cookie';
import Config from '@/settings';
var TokenKey = Config.TokenKey;
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  // if () {
  //     return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  // } else return Cookies.set(TokenKey, token)
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getSafeEventParams(key) {
  return Cookies.get(key);
}
export function setSafeEventParams(key, value) {
  return Cookies.set(key, value);
}